import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  incidentListing: { loading: false, data: [], error: null },
  incidentDetail: { loading: false, data: null, error: null },
  incidentTimeline: { loading: false, data: [], error: null },
};

const incidentsSlice = createSlice({
  name: "afmsIncidents",
  initialState,
  reducers: {
    incidentListingStart: (state) => { state.incidentListing.loading = true; state.incidentListing.error = null; },
    incidentListingSuccess: (state, action) => { state.incidentListing.loading = false; state.incidentListing.data = action.payload; },
    incidentListingFailure: (state, action) => { state.incidentListing.loading = false; state.incidentListing.error = action.payload; },

    incidentDetailStart: (state) => { state.incidentDetail.loading = true; state.incidentDetail.error = null; },
    incidentDetailSuccess: (state, action) => { state.incidentDetail.loading = false; state.incidentDetail.data = action.payload; },
    incidentDetailFailure: (state, action) => { state.incidentDetail.loading = false; state.incidentDetail.error = action.payload; },

    incidentTimelineStart: (state) => { state.incidentTimeline.loading = true; state.incidentTimeline.error = null; },
    incidentTimelineSuccess: (state, action) => { state.incidentTimeline.loading = false; state.incidentTimeline.data = action.payload; },
    incidentTimelineFailure: (state, action) => { state.incidentTimeline.loading = false; state.incidentTimeline.error = action.payload; },
  },
});

export const {
  incidentListingStart, incidentListingSuccess, incidentListingFailure,
  incidentDetailStart, incidentDetailSuccess, incidentDetailFailure,
  incidentTimelineStart, incidentTimelineSuccess, incidentTimelineFailure,
} = incidentsSlice.actions;

export default incidentsSlice.reducer;
